const Regexes = {
  cnicWithoutDashes: /^[0-9+]{5}[0-9+]{7}[0-9]{1}$/,
};

export default Regexes;
